import { Whatsapp } from "react-bootstrap-icons";
import { WHATSAPP_URL } from "../ui/ContactStrip";
import { currentLanguage } from "../ui/notify";
import "./WhatsAppButton.css";

// A floating WhatsApp contact button pinned to the bottom-right of every public
// page. The toast stack sits bottom-left, so the two never overlap. The number
// and link are the shared WHATSAPP_URL used across the marketing pages.
const LABELS = {
    geo: "დაგვიკავშირდით WhatsApp-ით",
    en: "Chat with us on WhatsApp",
    ru: "Напишите нам в WhatsApp",
    am: "Գրեք մեզ WhatsApp-ով",
};

const WhatsAppButton = () => {
    const label = LABELS[currentLanguage()] || LABELS.geo;
    return (
        <a
            className="cx-whatsapp-fab"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            aria-label={label}
            title={label}
        >
            <Whatsapp aria-hidden="true" />
        </a>
    );
};

export default WhatsAppButton;
